import { MockLoginScreen } from 'app/features/app-login/mock-login'

const MockLogin = () => <MockLoginScreen />

MockLogin.displayName = 'MockLoginScreen'

export default MockLogin
